"use strict";

import Common from "../Common";
import CommonGame from "../CommonGame";
import SimpleScene from "./SimpleScene";

export default class GallerySelectionScene extends SimpleScene {
    constructor() {
        super();

        // Attributes.
        this._colourItBtn = null;
        this._drawItBtn = null;
        this._colourItText = null;
        this._drawItText = null;
        this._titleSprite = null;
        this._titleText = null;
        this._colourItSprite = null;
        this._drawItSprite = null;
    }

    init() {

        this._bgSprite = new PIXI.Sprite(Common.assets.getTexture("bg"));//not sure why this is like this, but must create background first
        super.init();


        /*
         deprecated title sprite and text
         */

        // Title sprite.
        // this._titleSprite = new PIXI.Sprite(Common.assets.getTexture("popup_box_title_bg"));
        //  this._titleSprite.y = this._titleSprite.height * 0.5;
        //  this._titleSprite.x = Common.STAGE_WIDTH * 0.5;
        //  this._titleSprite.anchor = new PIXI.Point(0.5, 0.75);
        //  this.addChild(this._titleSprite);

        // Title text.
        /*
         let bkText = P3.createText("GAMES", {
         fill: [0xfff8b3, 0xfac109],
         size: "90px",
         wordWrap: true,
         wordWrapWidth: 500,
         stroke: 0x23a838,
         strokeThickness: 14,
         align: "centre"
         });

         this._titleText = P3.createText("GAMES", {
         fill: [0xfff8b3, 0xfac109],
         size: "90px",
         wordWrap: true,
         wordWrapWidth: 500,
         stroke: 0x006130,
         align: "centre",
         strokeThickness: 8
         });

         this._titleText.anchor = bkText.anchor = new PIXI.Point(0.5, 0.5);
         this._titleText.y = bkText.y = -45;
         this._titleSprite.addChild(bkText, this._titleText);
         */

        // Colour gallery.
        // Image.
        let btnStatesAux = new P3.ButtonStates(
            Common.assets.getTexture("game_colour"),
            Common.assets.getTexture("game_colour"),
            Common.assets.getTexture("game_colour")
        );
        this._colourItSprite = new P3.Button(btnStatesAux);
        this._colourItSprite.signals.click.addOnce(this._onColourGalleryButton_Click, this);
        this._colourItSprite.anchor = new PIXI.Point(0.5, 0.5);
        this._colourItSprite.position = new PIXI.Point(
            Common.STAGE_WIDTH * 0.5 - 255,
            Common.STAGE_HEIGHT * 0.5);
        this.addChild(this._colourItSprite);

        const colourItTextConf = {
            size: "75px",
            fill: "#3992ff",
            stroke: "#2c1812",
            wordWrapWidth: 400
        };
        this._colourItText = P3.createMultiText("COLOUR_IT", colourItTextConf);

        this._colourItText.anchor = new PIXI.Point(0.5, 0.5);
        this._colourItText.y = -this._colourItSprite.height * 0.5 + 15;
        this._colourItSprite.addChild(this._colourItText);

        // Button.
        this._colourItBtn = createButton("play_large", "primary_large");
        this._colourItBtn.anchor = new PIXI.Point(0.5, 0.5);
        this._colourItBtn.y = this._colourItSprite.y + this._colourItSprite.height * 0.5;
        this._colourItBtn.x = this._colourItSprite.x;
        this._colourItBtn.overSoundName = "sfx_ui_rollover_00";
        this._colourItBtn.downSoundName = "sfx_btn_play_start_doorbell_00";
        this._colourItBtn.signals.click.addOnce(this._onColourGalleryButton_Click, this);
        this.addChild(this._colourItBtn);

        // Draw gallery.
        // Image.
        btnStatesAux = new P3.ButtonStates(
            Common.assets.getTexture("game_draw"),
            Common.assets.getTexture("game_draw"),
            Common.assets.getTexture("game_draw")
        );
        this._drawItSprite = new P3.Button(btnStatesAux);
        this._drawItSprite.signals.click.addOnce(this._onDrawGalleryButton_Click, this);

        this._drawItSprite.anchor = new PIXI.Point(0.5, 0.5);
        this._drawItSprite.position = new PIXI.Point(
            Common.STAGE_WIDTH * 0.5 + 255,
            Common.STAGE_HEIGHT * 0.5);
        this.addChild(this._drawItSprite);

        this._drawItText = P3.createText("DRAW_IT", {
            size: "75px",
            fill: "white",
            stroke: "#2c1812",
            stokeThickness: 6,
            wordWrap: true,
            wordWrapWidth: 300
        }, "truetype");

        this._drawItText.anchor = new PIXI.Point(0.5, 0.5);
        this._drawItText.y = -this._drawItSprite.height * 0.5 + 15;
        this._drawItSprite.addChild(this._drawItText);
        // Button.

        this._drawItBtn = createButton("play_large", "primary_large");
        this._drawItBtn.anchor = new PIXI.Point(0.5, 0.5);
        this._drawItBtn.position.y = this._drawItSprite.y + this._drawItSprite.height * 0.5;
        this._drawItBtn.position.x = this._drawItSprite.x;
        this._drawItBtn.overSoundName = "sfx_ui_rollover_00";
        this._drawItBtn.downSoundName = "sfx_btn_play_start_doorbell_00";
        this._drawItBtn.signals.click.addOnce(this._onDrawGalleryButton_Click, this);
        this.addChild(this._drawItBtn);

        super.createSharedControls(this);
        this._uiTopBarSharedControls.muteBtn.visible = true;
        this._uiTopBarSharedControls.backBtn.visible = true;
        this._uiTopBarSharedControls.signals.onBackBtn_Click.addOnce(function () {
            this.signals.previous.dispatch(this);
        }, this);
    }

    destroy() {
        super.destroy({children: true});
        TweenMax.killAll();
    }

    animateIn() {
        //this._titleSprite.y -= 100;
        // TweenMax.to(this._titleSprite, 1.5, {y: this._titleSprite.y + 100, ease: Elastic.easeOut});

        this._drawItSprite.x += 100;
        this._drawItSprite.alpha = 0;
        TweenMax.to(this._drawItSprite, 0.25, {alpha: 1, x: this._drawItSprite.x - 100, ease: Sine.easeOut});

        this._colourItSprite.x -= 100;
        this._colourItSprite.alpha = 0;
        TweenMax.to(this._colourItSprite, 0.25, {alpha: 1, x: this._colourItSprite.x + 100, ease: Sine.easeOut});

        this._drawItBtn.alpha = 0;
        this._drawItBtn.scale = new PIXI.Point();
        TweenMax.to(this._drawItBtn, 0.25, {alpha: 1, ease: Sine.easeOut, delay: 0.2});
        TweenMax.to(this._drawItBtn.scale, 0.5, {x: 1, y: 1, ease: Elastic.easeOut, delay: 0.2});

        this._colourItBtn.alpha = 0;
        this._colourItBtn.scale = new PIXI.Point();
        TweenMax.to(this._colourItBtn, 0.25, {alpha: 1, ease: Sine.easeOut, delay: 0.35});
        TweenMax.to(this._colourItBtn.scale, 0.5, {x: 1, y: 1, ease: Elastic.easeOut, delay: 0.35});
    }

    //----EVENTS----//

    _onColourGalleryButton_Click() {
        CommonGame.selectedGallery = CommonGame.GALLERY_ID_COLOUR_IT;
        this.signals.next.dispatch(this);
    }

    _onDrawGalleryButton_Click() {
        CommonGame.selectedGallery = CommonGame.GALLERY_ID_DRAW_IT;
        this.signals.next.dispatch(this);
    }
}
